var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('print-page',{attrs:{"character":_vm.$route.params.character}}),_c('v-row',{staticStyle:{"page-break-after":"always"}}),_c('print-page',{attrs:{"character":_vm.$route.params.character.Spirit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }